import React from "react";
import { UsersIcon } from "../common/icons";

interface RecipientSelectionBarProps {
  selectedCount: number;
  onClearSelection: () => void;
}

/**
 * RecipientSelectionBar - Shows count of selected recipients with clear option
 */
const RecipientSelectionBar: React.FC<RecipientSelectionBarProps> = ({
  selectedCount,
  onClearSelection,
}) => {
  return (
    <div className="su-recipients-selection-bar">
      <div className="su-recipients-selection-info">
        <UsersIcon className="w-5 h-5 su-recipients-selection-icon" />
        <span className="su-recipients-selection-count">
          {selectedCount} recipient{selectedCount !== 1 ? "s" : ""} selected
        </span>
      </div>

      {selectedCount > 0 && (
        <button
          className="su-recipients-clear-btn"
          onClick={onClearSelection}
        >
          Clear selection
        </button>
      )}
    </div>
  );
};

export default RecipientSelectionBar;


